function hydrateDiscountTipIcons(root) {
  (root || document).querySelectorAll('.card-discount-tip__icon').forEach(function (el) {
    if (el.getAttribute('data-hydrated') === 'true') return;
    var script = el.querySelector('script[type="application/json"]');
    if (!script) return;
    try {
      var svg = JSON.parse(script.textContent);
      if (svg) {
        el.innerHTML = svg;
        el.setAttribute('data-hydrated', 'true');
      }
    } catch (e) {}
  });
}

function showDiscountTipCopiedTooltip(btn) {
  var existing = btn.querySelector('.card-discount-tip__copied');
  if (existing) existing.remove();

  var tip = document.createElement('span');
  tip.className = 'card-discount-tip__copied';
  tip.setAttribute('role', 'status');
  tip.textContent = 'Copied';
  btn.appendChild(tip);

  window.setTimeout(function () {
    tip.remove();
  }, 1000);
}

function copyDiscountTipCode(btn) {
  var code = btn.getAttribute('data-discount-tip-copy');
  if (!code) return;

  var done = function () {
    showDiscountTipCopiedTooltip(btn);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(done).catch(function () {
      fallbackCopyDiscountTipCode(code, done);
    });
  } else {
    fallbackCopyDiscountTipCode(code, done);
  }
}

function fallbackCopyDiscountTipCode(code, done) {
  var input = document.createElement('textarea');
  input.value = code;
  input.setAttribute('readonly', '');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  try {
    document.execCommand('copy');
    done();
  } catch (e) {}
  document.body.removeChild(input);
}

function bindDiscountTipCopy() {
  if (document.documentElement.hasAttribute('data-discount-tip-copy-bound')) return;
  document.documentElement.setAttribute('data-discount-tip-copy-bound', 'true');

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-discount-tip-copy]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    copyDiscountTipCode(btn);
  });
}

function bindDiscountTipObserver() {
  hydrateDiscountTipIcons();
  bindDiscountTipCopy();
  var grid = document.getElementById('product-grid');
  if (grid && window.MutationObserver && !grid.hasAttribute('data-discount-tip-observed')) {
    grid.setAttribute('data-discount-tip-observed', 'true');
    new MutationObserver(function () {
      hydrateDiscountTipIcons(grid);
    }).observe(grid, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindDiscountTipObserver);
} else {
  bindDiscountTipObserver();
}

document.addEventListener('shopify:section:load', function () {
  hydrateDiscountTipIcons();
});
